import React from "react";
import { StaticQuery, graphql } from "gatsby";

import HeroSlider from "../components/HeroSlider";
import ThumbnailSlider from "../components/ThumbnailSlider";
import VerticalAccordion from "../components/VerticalAccordion";
import SliderPeak from "../components/SliderPeak";
import VideoBlock from "../components/VideoBlock";
import "../styles/slider.sass";
import TwoColumnGridContent from "../components/TwoColumnGridContent";
import TemplateWrapper from "../components/Layout";
import GoogleReviews from '../components/GoogleReviews';
import TextCtaBlock from "../components/TextCtaBlock";

const IndexPageNewTemplate = ({ data }) => {
  const { frontmatter } = data.markdownRemark;
  const { heroSlides, peakSlides, videoContent, columnGridContent } = frontmatter;

  const ctaBlockData = {
    title: "NOBODY WANTS TO PEDAL BACK TO TOWN!",
    subtitle: [
      "Hazard County Shuttle is the only bike shuttle company in Moab that offers mountain bike trailhead departures for Mag-7, Porcupine Rim, Raptor Route, and the Whole Enchilada Lower Section.",
    ],
    description: [
      "This means your car will be waiting for you at the end of your ride, eliminating the pedal back into town.",
    ],
    smalldesc: [
      "Our shuttle service is designed to save you time, money, and energy.",
      "We depart from the trailheads, alleviating the pedal back to town.",
      "We offer multiple pick-up times and locations to best suit your needs and fit your schedule.  "
    ]
  };

  return (
    <TemplateWrapper>
      <div style={{ background: "#000" }}>
        <HeroSlider {...heroSlides} />
        <TextCtaBlock data={ctaBlockData} />
        <ThumbnailSlider />
        <VerticalAccordion />
        <VideoBlock video={videoContent} />
        <TwoColumnGridContent columnGridContent={columnGridContent} />
        <GoogleReviews />
        <SliderPeak items={peakSlides} />
      </div>
    </TemplateWrapper>
  );
};

const IndexPageNew = () => (
  <StaticQuery
    query={graphql`
      query indexPageNewQuery {
        markdownRemark(frontmatter: { templateKey: { eq: "index-page-new" } }) {
          frontmatter {
            title
            subtitle
            heroSlides {
              subtitle
              title
              background {
                type
                url {
                  publicURL
                }
              }
              mobileBackground {
                type
                url {
                  publicURL
                }
              }
              buttonText
              buttonLink
            }
            peakSlides {
              title
              description
              image
              buttonText
              buttonLink
            }
            videoContent {
              title
              videoUrl {
                publicURL
              }
            }
            columnGridContent {
              left {
                title
                image {
                  childImageSharp {
                    gatsbyImageData(
                      quality: 100
                      width: 1280
                      height: 850
                      layout: CONSTRAINED
                      transformOptions: {
                        fit: COVER
                        cropFocus: ATTENTION
                      }
                      placeholder: BLURRED
                    )
                  }
                }
                buttonText
                buttonUrl
              }
              right {
                title
                image {
                  childImageSharp {
                    gatsbyImageData(
                      quality: 100
                      layout: FULL_WIDTH
                      placeholder: BLURRED
                    )
                  }
                }
                buttonText
                buttonUrl
              }
            }
          }
        }
      }
    `}
    render={(data) => <IndexPageNewTemplate data={data} />}
  />
);

export default IndexPageNew;
